import * as React from 'react';
import { Redirect, Route, Switch } from 'react-router';
import { routes } from '@ui/routes';

import Regions from '../pages/Regions';
import Cities from '../pages/Cities';
import CityStores from '../pages/CityStores';
import Store from '../pages/Store';
import Requests from '../pages/Requests';

const ManagerRoutes = () => (
  <Switch>
    <Route exact path={routes.regions} component={Regions} />
    <Route path={routes.citiesRegion} component={Cities} />
    <Route path={routes.cityStores} component={CityStores} />
    <Route path={routes.store} component={Store} />
    <Route path={routes.requests} component={Requests} />
    <Redirect to={routes.regions} />
  </Switch>
);

export default ManagerRoutes;



// WEBPACK FOOTER //
// ./src/Routes/ManagerRoutes.tsx